import React, { useEffect, useState, useContext } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getPDFApply } from '../../eDocumentsSlice';

const NtsResult_04 = () => {
  const dispatch = useDispatch();
  const { ntsResult } = useSelector(state => state.eDocuments);

  useEffect(() => {
    dispatch(getPDFApply({ htmPCd: '4' }));
  }, []);

  return (
    <div className="yearendManualContentsBox">
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>인원별 합계</p>
        <Table01 ntsResult={ntsResult} />
      </div>

      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>유형별 합계</p>
        <Table02 ntsResult={ntsResult} />
      </div>
      <div className={'ntsResultBox'}>
        <p className={'body2Bold subPoint3 ntsResultTitle'}>기부금 입력 상세 내역</p>
        <Table03 ntsResult={ntsResult} />
      </div>
    </div>
  );
};

export default NtsResult_04;

const Table01 = ({ ntsResult }) => {
  const headList = [
    // { name: "순번", key: "", width: "70px" },
    { name: '성명', key: 'htmPerNm', width: '50%' },
    { name: '주민등록번호', key: 'htmRegNum', width: '233.33px' },
    { name: '합계', key: 'sum', width: '50%', align: 'right' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{ borderTop: '1px solid #D9D9D9' }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.listPerSum?.map(
        (item, index) =>
          item.htmRegNum && (
            <div key={index} className="displayFlex tableTr">
              {headList.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{ justifyContent: header.align }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ),
      )}
    </div>
  );
};

const Table02 = ({ ntsResult }) => {
  const headList = [
    // { name: '순번', width: '70px' },
    { name: '유형', width: '50%', key: 'htmPerNm' },
    { name: '합계', width: '50%', key: 'sum', align: 'right' },
  ];

  return (
    <div>
      <div className="displayFlex tableTr">
        {headList.map((item, index) => (
          <div
            className="tableTitle captionBold"
            key={index}
            style={{ borderTop: '1px solid #D9D9D9' }}>
            {item.name}
          </div>
        ))}
      </div>
      {ntsResult?.listPerSum?.map(
        (item, index) =>
          item.htmRegNum == '' && (
            <div key={index} className="displayFlex tableTr">
              {headList.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{ justifyContent: header.align }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ),
      )}
    </div>
  );
};

const Table03 = ({ ntsResult }) => {
  const headListGroup1 = [
    { name: '기부자', width: '23%', key: 'htmPerNm' },
    {
      name: '기부자 주민번호',
      width: '25%',
      key: 'htmRegNum',
    },
    { name: '단체명', width: '27%', key: 'htm004' },
    { name: '사업자번호', width: '25%', key: 'htm003' },
  ];

  const headListGroup2 = [
    { name: '날짜', width: '23%', key: 'htmDate' },
    {
      name: '기부금액 합계',
      width: '25%',
      key: 'htm001',
      align: 'right',
    },
    {
      name: '공제대상 기부금액',
      width: '27%',
      key: 'htm007',
      align: 'right',
    },
    {
      name: '기부장려금 신청금액',
      width: '25%',
      key: 'htm006',
      align: 'right',
    },
  ];

  const headList = [headListGroup1, headListGroup2];
  return (
    <div className="tableWrapper">
      <div>
        {headList.map((headers, _index) => (
          <div className="displayFlex tableTr" key={_index}>
            {headers.map((item, index) => (
              <div
                className="tableTitle captionBold"
                key={index}
                style={{
                  width: item.width,
                  flex: 'none',
                  borderTop: _index == headList.length - 1 && 'none',
                }}>
                {item.name}
              </div>
            ))}
          </div>
        ))}
      </div>

      {/* 데이터 행 */}
      {ntsResult?.list?.map((item, index) => (
        <React.Fragment key={index}>
          {headList.map((headers, headerIndex) => (
            <div className="displayFlex tableTr" key={headerIndex}>
              {headers.map((header, _index) => (
                <div
                  className="tableBody captionMedium"
                  key={_index}
                  style={{
                    width: header.width,
                    flex: 'none',
                    justifyContent: header.align,
                  }}>
                  {item[header.key]}
                </div>
              ))}
            </div>
          ))}
        </React.Fragment>
      ))}
    </div>
  );
};
